import { type FC, type ReactNode } from "react";
import useCustomAntStyles from "./CustomAntStyles.styles";
import { Flex } from "antd";

interface CustomAntStylesProps {
  children: ReactNode;
}

const CustomAntStyles: FC<CustomAntStylesProps> = ({ children }) => {
  const { styles } = useCustomAntStyles();

  return (
    <Flex className={styles.wrapper} justify="center" align="center">
      <Flex className={styles.content}>{children}</Flex>
    </Flex>
  );
};
export default CustomAntStyles;
